import { createStore } from "vuex";
import client from '../client/client';
// import teststore from './teststore';

export default createStore({
    // modules : {
    //     teststore,
    // },
    state: {
        // token : null,
        isLogin: '123',
        recipeLists: [],
        recipePage: 0,
    },
    getters: {
        // getToken(state){
        //     return state.token;
        // },
        isLogin(state) {
            return state.isLogin;
        },
        recipeLists(state) {
            return state.recipeLists;
        },
        recipePage(state) {
            return state.recipePage;
        }
    },
    mutations: {
        // setToken(state, token) {
        //     state.token = token;
        // },
        setLogin(state, payload) {
            state.isLogin = payload.isLogin;
        },
        setRecipeLists(state, payload) {
            state.recipeLists = payload.recipeLists;
        },
        setRecipePage(state, payload) {
            state.recipePage = payload.recipePage;
        },
    },
    actions: {
        // setToken({commit} , token) {
        //     commit('setToken', token);
        // },
        isLoginUpdate({ commit }, isLogin) {
            commit("setLogin", {
                isLogin
            });
        },
        isRecipeListsUpdate({ commit }, recipeLists) {
            commit("setRecipeLists", {
                recipeLists
            });
        },
        isRecipePageUpdate({ commit }, recipePage) {
            commit("setRecipePage", {
                recipePage
            });
        },
    },
});